class ProductForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("variant:changed", (e) => {
      const { variant, frameSizeVariants } = e.detail;

      console.log(`variant`, variant);

      this._updateAtcs(variant);
      this._updateIdInputs(variant);

      if (!variant) return;

      this._updatePrices(variant);
      this._updateUrl(variant);
      this._updateOptionPrices(frameSizeVariants);
      this._updateSkus(variant);
    });
  }

  disconnectedCallback() {}

  get atcs() {
    return this.querySelectorAll("[data-product-form-atc]");
  }

  get prices() {
    return this.querySelectorAll("[data-main-product-price]");
  }

  get idInputs() {
    return this.querySelectorAll('input[name="id"]');
  }

  get skus() {
    return this.closest(".shopify-section").querySelectorAll(
      "[data-description-box-sku]",
    );
  }

  get updateUrl() {
    return !this.hasAttribute("disable-update-url");
  }

  _updateAtcs(variant) {
    this.atcs.forEach((atc) => {
      atc.disabled = !variant || !variant.available;
    });
  }

  _updatePrices(variant) {
    this.prices.forEach((price) => {
      this._updatePriceEl(price, variant);
    });
  }

  _updateSkus(variant) {
    this.skus.forEach((sku) => {
      sku.innerHTML = variant.sku || "";
    });
  }

  _updateOptionPrices(frameSizeVariants) {
    frameSizeVariants.forEach(({ productOptionId, variant }) => {
      const productOptionPrice = this.querySelector(
        `[data-option-value-price="${productOptionId}"]`,
      );

      if (!productOptionPrice) return;

      this._updatePriceEl(productOptionPrice, variant);
    });
  }

  _updateIdInputs(variant) {
    this.idInputs.forEach((idInput) => {
      idInput.value = variant?.id || "";
    });
  }

  _updateUrl(variant) {
    const url = new URL(window.location);

    if (!window.Shopify.designMode && this.updateUrl) {
      url.searchParams.set("variant", variant.id);
      window.history.replaceState("", "", url);
    }
  }

  _updatePriceEl(price, variant) {
    price.setAttribute("price", variant.price / 100);
    price.setAttribute("compare-at-price", variant.compare_at_price / 100);
    price.setAttribute("currency", window.Shopify.currency.active);
    price.setAttribute("dynamic", "");
  }
}

if (!customElements.get("product-form")) {
  customElements.define("product-form", ProductForm);
}
